import { collection, deleteDoc, doc, getDocs, getFirestore, query, serverTimestamp, setDoc, Timestamp, where, writeBatch } from "firebase/firestore"
import { IInventoryItemBrand, IInventoryItemCateogry, ProductCategorySchema } from "shared/types"



const addBrand = async (brand_name:string, user_id:string, shop_name:string)=>{

    try {

        const ref = doc(getFirestore(), "businesses", user_id, "shops", shop_name, "product-brands", brand_name)

        await setDoc(ref, {
            name: brand_name,
            total_sales: 0,
            gross_revenue: 0,
            gross_profit: 0,
            created_at: serverTimestamp()
        }, {merge:false})

        return {
            name: brand_name,
            total_sales: 0,
            gross_revenue: 0,
            gross_profit: 0,
            created_at: new Date().toDateString()
        }
        
    } catch (error) {
        throw error
    }
    
}

const addBrandBulk = async (array_data:IInventoryItemBrand[], user_id:string, shop_name:string)=>{

    try {

        const batch = writeBatch(getFirestore())

        array_data.forEach((brand)=>{

            const keys = Object.keys(brand)
            const values = Object.values(brand)

            const _brand:any = {}
            keys.forEach((key, index)=>{
                _brand[key.toLowerCase().replace(" ", "_")] = values[index]
            })

            const brandRef = doc(getFirestore(), "businesses", user_id, "shops", shop_name, "product-brands", _brand.name)
            batch.set(brandRef, {
                name: _brand.name,
                total_sales: 0,
                gross_revenue: 0,
                gross_profit: 0,
                created_at: serverTimestamp()
            })
            
        })

        await batch.commit()
        return
        
    } catch (error) {
        throw error
    }
    
}

const addCategory = async (category_name:string, user_id:string, shop_name:string)=>{

    try {

        const ref = doc(getFirestore(), "businesses", user_id, "shops", shop_name, "product-categories", category_name)

        await setDoc(ref, {
            name: category_name,
            total_sales: 0,
            gross_revenue: 0,
            gross_profit: 0,
            created_at: serverTimestamp()
        }, {merge:false})

        return {
            name: category_name,
            total_sales: 0,
            gross_revenue: 0,
            gross_profit: 0,
            created_at: new Date().toDateString()
        }
        
    } catch (error) {
        throw error
    }
    
}

const addCategoryBulk = async (array_data:ProductCategorySchema[], user_id:string, shop_name:string)=>{

    try {

        const batch = writeBatch(getFirestore())

        array_data.forEach((category)=>{

            const keys = Object.keys(category)
            const values = Object.values(category)

            const _category:any = {}
            keys.forEach((key, index)=>{
                _category[key.toLowerCase().replace(" ", "_")] = values[index]
            })

            const category_ref = doc(getFirestore(), "businesses", user_id, "shops", shop_name, "product-categories", _category.name)
            batch.set(category_ref, {
                name: _category.name,
                total_sales: 0,
                gross_revenue: 0,
                gross_profit: 0,
                created_at: serverTimestamp()
            })
            
        })

        await batch.commit()
        return
        
    } catch (error) {
        throw error
    }
    
}

const deleteBrand = async(brand_id:string, business_id:string, shop_id:string)=>{

    try {

        const ref = doc(getFirestore(), "businesses", business_id, "shops", shop_id, "product-brands", brand_id)
        await deleteDoc(ref)
        return
        
    } catch (error) {
        throw error
    }
    
}

const deleteBrandBulk = async(brand_array:string[], business_id:string, shop_id:string)=>{
    
    try {
        
        const batch = writeBatch(getFirestore())
        
        brand_array.forEach((brand_id)=>{
            
            const ref = doc(getFirestore(), "businesses", business_id, "shops", shop_id, "product-brands", brand_id)
            
            batch.delete(ref)
            
        })

        await batch.commit()
        
        
    } catch (error) {
        throw error
    }
    
}


const deleteCategory = async (category_id:string, business_id:string, shop_id:string)=>{

    try {
        
        const ref = doc(getFirestore(), "businesses", business_id, "shops", shop_id, "product-categories", category_id)
        await deleteDoc(ref)
        return
        
    } catch (error) {
        throw error
    }
    
}

const deleteCategoryBulk = async (category_ids:string[], business_id:string, shop_id:string)=>{

    try {

        const batch = writeBatch(getFirestore())

        category_ids.forEach((category_id)=>{

            const ref = doc(getFirestore(), "businesses", business_id, "shops", shop_id, "product-categories", category_id)

            batch.delete(ref)
            
        })

        await batch.commit()
        return
        
    } catch (error) {
        throw error
    }
    
}


const getBrands = async(user_id:string, shop_name:string)=>{

    try {

        const brands:IInventoryItemBrand[] = []
        const queryRef = query(collection(getFirestore(), "businesses", user_id, "shops", shop_name, "product-brands"))
        const res = await getDocs(queryRef)

        res.forEach((brand)=>{
            brands.push({
                ...brand.data() as IInventoryItemBrand,
                created_at: (new Timestamp(brand.data().created_at.seconds, brand.data().created_at.nanoseconds)).toMillis()
            })
        })

        return brands
        
    } catch (error) {
        throw error
    }
    
}

const getBrandsByDateRange = async (start_date:Date, end_date:Date, user_id:string, shop_name:string)=>{

    try {

        const brands:IInventoryItemBrand[] = []

        const ref = collection(getFirestore(), "businesses", user_id, "shops", shop_name, "product-brands")
        const q = query(ref, where("created_at", ">=", start_date), where("created_at", "<=", end_date))

        const res = await getDocs(q)
        res.forEach((brand)=>{
            if(brand.exists()){
                brands.push({
                    ...brand.data() as IInventoryItemBrand,
                    created_at: (new Timestamp(brand.data().created_at.seconds, brand.data().created_at.nanoseconds)).toMillis()
                })
            }
        })

        return brands
        
    } catch (error) {
        throw error
    }
    
}

const getCategories = async(user_id:string, shop_name:string)=>{

    try {

        const categories:IInventoryItemCateogry[] = []
        const queryRef = query(collection(getFirestore(), "businesses", user_id, "shops", shop_name, "product-categories"))
        const res = await getDocs(queryRef)

        res.forEach((category)=>{
            categories.push({
                ...category.data() as IInventoryItemCateogry,
                created_at: (new Timestamp(category.data().created_at.seconds, category.data().created_at.nanoseconds)).toMillis()
            })
        })

        return categories
        
    } catch (error) {
        throw error
    }
    
}

const getCategoriesByDateRange = async (start_date:Date, end_date:Date, user_id:string, shop_name:string)=>{

    try {

        const categories:IInventoryItemCateogry[] = []

        const ref = collection(getFirestore(), "businesses", user_id, "shops", shop_name, "product-categories")
        const q = query(ref, where("created_at", ">=", start_date), where("created_at", "<=", end_date))

        const res = await getDocs(q)
        res.forEach((category)=>{
            if(category.exists()){
                categories.push({
                    ...category.data() as IInventoryItemCateogry,
                    created_at: (new Timestamp(category.data().created_at.seconds, category.data().created_at.nanoseconds)).toMillis()
                })
            }
        })

        return categories
        
    } catch (error) {
        throw error
    }
    
}


const Catalog = {
    addBrand,
    addBrandBulk,
    addCategory,
    addCategoryBulk,
    deleteBrand,
    deleteBrandBulk,
    deleteCategory,
    deleteCategoryBulk,
    getBrands,
    getBrandsByDateRange,
    getCategoriesByDateRange,
    getCategories
}

export default Catalog